import { render, staticRenderFns } from "./ReportOrders.vue?vue&type=template&id=6455f183&"
import script from "./ReportOrders.vue?vue&type=script&lang=js&"
export * from "./ReportOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports